export default __webpack_public_path__ + "static/media/Ballroll_00289.a5f38aee.png";